import { Box, Paper, Grid, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import AppTextareaInput from "../../app/components/AppTextareaInput";
import MembershipFormModel from "../../app/models/membership/membershipFormModel";
import { useAppSelector } from "../../app/store/configureStore";
import AppAutocomplete from "../../app/components/AppAutocomplete";
import { MapCountriesToAutocompleteItems } from "../../app/utils/convertStaticDataToAutocompleteItems";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";

export default function PostalAddress() {
    const appInsights = useAppInsightsContext();
    const methods = useFormContext();
    const { control, reset } = methods;

    const { countries } = useAppSelector(state => state.ReferenceData);
    const { personalDetails } = useAppSelector(state => state.personalDetail);

    const {
        formField: {
            PostalAddressLines,
            PostalAddressCountry
        }
    } = MembershipFormModel;

    useEffect(() => {
        if (personalDetails !== undefined && personalDetails !== null && countries && countries?.length > 0) {

            reset({
                [PostalAddressLines.name]: (personalDetails.postalAddress === null ||
                    personalDetails.postalAddress === undefined) ? '' : personalDetails.postalAddress,
                [PostalAddressCountry.name]: (personalDetails.postalAddressCountryId === null ||
                    personalDetails.postalAddressCountryId === undefined) ? '' : personalDetails.postalAddressCountryId
            });
            appInsights.trackEvent({ name: "Donation - Postal address - on load" });
        }
    }, [personalDetails, countries, reset]);

    return <>
        <Box sx={{ width: '100%' }} component={Paper}>

            <Grid container rowSpacing={4} sx={{ margin: "2%" }}>

                <Grid size={{ xs: 12 }}></Grid>
                
                <Grid size={{ xs: 12 }}>
                    <Typography variant='subtitle1' sx={{ fontWeight: "500" }}>Postal address</Typography>
                    <Typography variant="subtitle1" sx={{ color: 'primary.main' }}>
                        {PostalAddressLines.information_text}
                    </Typography>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppTextareaInput control={control} name={PostalAddressLines.name} label={PostalAddressLines.label}
                        maxStringCount={PostalAddressLines.maxStringCount} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppAutocomplete control={control} name={PostalAddressCountry.name} label={PostalAddressCountry.label}
                        items={MapCountriesToAutocompleteItems(countries ?? [])} />
                </Grid>

                <Grid size={{ xs: 12 }}></Grid>

            </Grid>
        </Box>
    </>
}